import { moduleUnlicensed } from '@/libs/license'

export const PrintSuccess = (message: string) => {
    const toast = useToast()
    toast.add({ title: message, color: 'success', duration: 3000 })
}

export const PrintError = (message: string) => {
    // Nothing is said over the module notice. Every screen that was mid-load when the
    // API refused the module calls this with its own "could not load" line, and a
    // stack of them piling up on top of the one explanation reads as a portal falling
    // apart rather than a hotel that has not bought something.
    if (moduleUnlicensed.value) return

    const toast = useToast()
    toast.add({ title: message, color: 'error', duration: 5000 })
}
